export default __webpack_public_path__ + "static/media/Frota (Real Size).5800cc08.svg";